import React from "react";
import TopBar from "../TopBar/TopBar";
import ReactMarkdown from 'react-markdown';
import "./CookiePolicy.scss";

const CookiePolicy: React.FC = () => {
  const markdownContent = `## COOKIE POLICY

### **1. What Are Cookies?**

Cookies are small text files stored on your device that help us recognize your browser and remember certain information to improve your experience. They can be "session" cookies (deleted when you close your browser) or "persistent" cookies (which stay on your device for a set period).

### **2. How We Use Cookies**

We use cookies to ensure the "Bullsh*t Detector" and other AI-driven features function correctly.

| Category | Purpose | Necessity |
| :---- | :---- | :---- |
| **Strictly Necessary** | Essential for secure login, processing vehicle reports, and maintaining your session. | Mandatory |
| **Functional** | Remembers your preferences, such as your search history or display settings (e.g., Light/Dark mode). | Optional |
| **Analytics** | Helps us understand how users interact with our "Scout" reports so we can improve the AI's accuracy. | Optional |
| **Lead Generation** | Used when you opt-in to "push" vehicle data to dealers to ensure the correct information is transferred. | Optional |

### 

### **3. Third-Party Cookies**

We may use third-party services, such as **Google Analytics**, to monitor site traffic and performance. These providers may set their own cookies on your device to track your activity across different websites.

### **4. Managing Your Preferences**

You have the right to decide whether to accept or reject non-essential cookies.

* **On-Site Settings:** You can adjust your preferences at any time by clicking the **"Cookies settings"** link located in the footer of our website.  
* **Browser Controls:** Most web browsers allow you to block or delete cookies through their internal settings.  
* **Impact of Disabling:** Please note that if you disable "Strictly Necessary" cookies, certain features like report generation and secure document uploads may not function correctly.

### **5. Privacy of Uploaded Data**

As noted in our Terms of Service, cookies used for site analytics do **not** store the private documents or photos you upload for vehicle analysis. We process those documents securely and delete them after your report is generated.`

  return (
    <div className="cookie-policy-page">
      <TopBar title="Cookie Policy" />
      <div className="cookie-policy-content">
        <ReactMarkdown>{markdownContent}</ReactMarkdown>
      </div>
    </div>
  );
};

export default CookiePolicy;
